import React from "react";
import "./footer.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className='lux-footer'>
      {/* Floating hearts background */}
      <div className='lux-hearts'>
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} className='lux-heart'>
            ❤
          </span>
        ))}
      </div>
      <div className='lux-footer__container'>
        {/* ── Brand ── */}
        <div className='lux-footer__brand'>
          <h2 className='lux-footer__logo'>Uyirththunai</h2>
          <p className='lux-footer__tagline'>
            Where meaningful hearts are thoughtfully united into one timeless destiny. Our platform connects verified
            and trusted individuals for a lifelong journey of love and commitment.
          </p>
        </div>

        {/* ── Explore ── */}
        <div className='lux-footer__links'>
          <h3>Main Menu</h3>
          <ul>
            <li onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              Home
            </li>
            <li onClick={() => navigate("/about")} style={{ cursor: "pointer" }}>
              About Us
            </li>
            <li onClick={() => navigate("/contact")} style={{ cursor: "pointer" }}>
              Contact Us
            </li>
          </ul>
        </div>

        {/* ── Support ── */}
        <div className='lux-footer__links'>
          <h3>Support</h3>
          <ul>
            <li onClick={() => navigate("/faq")} style={{ cursor: "pointer" }}>
              FAQ
            </li>
            <li onClick={() => navigate("/privacy-policy")} style={{ cursor: "pointer" }}>
              Privacy Policy
            </li>
            <li onClick={() => navigate("/terms-and-conditions")} style={{ cursor: "pointer" }}>
              Terms & Conditions
            </li>
          </ul>
        </div>

        {/* ── Contact ── */}
        <div className='lux-footer__contact'>
          <h3>Connect With Us</h3>
          <p>📧 svenugoban1996@gmail.com</p>
          <p>📞 +94 75 344 0728</p>
        </div>
      </div>

      {/* ── Bottom ── */}
      <div className='lux-footer__bottom'>
        © {new Date().getFullYear()} Uyirththunai. Crafted with ❤️ for lifelong connections.
      </div>
    </footer>
  );
};

export default Footer;
